import React from "react";
import { FooterD } from "./styles";
import logo from "../../assets/logo.png";
import logo_reduzida from "../../assets/logo_reduzida.png";
import app_store from "../../assets/app_store.png";
import google_play from "../../assets/google_play.png";
import {Link} from "react-router-dom";

export default function Footer() {
    return (
        <FooterD>
            <div className="superior">
                <div className="direitaSuperior">
                    <img style={{ padding: "10px 0px" }} src={logo} alt="Logo YouGO!" />
                    <p>CNPJ: 50.090.131/0001-85</p>
                    <p>Rua central 60 - Canaã<br/>
                    Viana - ES</p>
                    <button><a href="https://maps.app.goo.gl/McHET9D1VcnwSUvw8">ABRIR NO MAPS</a></button>
                </div>
                <div className="centroSuperior">
                    <h3>Navegação do Site</h3>
                    <nav>
                        <Link to="/">Início</Link><br />
                        <Link to="/about">Sobre Nós</Link><br />
                        <Link to="/contact">Contato</Link><br />
                        <Link to="/tutorial-access">Tutorial de Acesso</Link><br />
                        <Link to="/password">Voucher de Leitura</Link>
                    </nav>
                </div>
                <div className="esquerdaSuperior">
                    <h3>Informações para Contato</h3>
                    <p style={{ fontWeight: 500 }}>(62) 99188-9274</p>
                    <p style={{ fontWeight: 500 }}>atendimentoaocliente@smartworldapp.com.br</p>
                  <p style={{ fontSize: 11 }}>Já é um associado? Baixe nosso app.</p>

                    <a href="https://play.google.com/store/apps/details?id=com.fabriciosiqueira.smartworldapp">
                        <img src={google_play} alt="Imagem" />
                    </a>
                    <a href="https://apps.apple.com/us/app/smart-world/id6751237043">
                        <img src={app_store} alt="Imagem" />
                    </a>
                </div>
            </div>
            
            <div className="inferior">
                <img src={logo_reduzida} alt="Logo YouGO!" className="logo-reduzida" />
                {/*<div className="centroInferior">
                    <a href="https://www.facebook.com/profile.php?id=100088731307287&mibextid=LQQJ4d"><FiFacebook style={{ color: "#000000", margin: "5px" }} /></a>
                    <a href="https://www.instagram.com/yougoappoficial/?hl=pt-br"><FaInstagram style={{ color: "#000000", margin: "5px" }} /></a>
                    <a href="http://bit.ly/3WS5YU8"><FaWhatsapp style={{ color: "#000000", margin: "5px" }} /></a>
                    <a href="https://www.threads.net/@yougoappoficial?igshid=MzRlODBiNWFlZA=="><FaThreads style={{ color: "#000000", margin: "5px" }} /></a>
                </div>*/}
                
                <div>
                    <Link to="/termos-de-uso">Termos de Uso </Link>
                    <Link to="/politica-de-privacidade">| Política de Privacidade</Link>
                </div>
            </div>
        </FooterD>
    );
};